<template>
	<span :class="classes"><slot /></span>
</template>

<script>
export default {
	name: 'InlineButtonIcon',
	props: {
		bg: {
			type: String,
			validator: v => ['grey', 'white'].includes(v),
			default: 'grey'
		}
	},
	computed: {
		classes() {
			return `inline-icon inline-icon--${this.bg}`
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.inline-icon {
	vertical-align: middle;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2em;
	height: 2em;
	border-radius: 50%;
	margin: 0 0.15em;

	&--grey {
		background-color: $grey-95;
	}
	&--white {
		background-color: $white;
	}

	svg {
		display: block;
		width: 1.25em;
		height: 1.25em;
	}
}
</style>
